const routes = [
  {
    index: true,
    label: 'Alex Kashi',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Publications',
    path: '/publications',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
